import React from 'react';

import Page from '@/components/layout/page';
import styles from '@/components/accounts/Accounts.module.css';
import Title from '@/components/commons/page-elements/Title';

import NavigationCard from '@/components/commons/site_navigation/NavigationCard';
import BigNavigationCard from '@/components/commons/site_navigation/BigNavigationCard';

function LandingWithCards({ mainTitle, bigNavCards, cards }) {
    return (
        <Page>
            <div className={`p-4 flex flex-wrap h-full bg-lightGray bg-opacity-30 items-start ${styles.home}`}>
                <div className="w-full pt-auto md:p-4">
                    <div className="flex justify-between relative flex-col md:flex-row">
                        <div className="pr-6 text-left mb-10">
                            <Title
                                title={mainTitle.title}
                                subtitle={mainTitle.subtitle}
                                small={mainTitle.small}
                                bold={mainTitle.bold}
                            >
                                {mainTitle.children}
                            </Title>
                        </div>
                    </div>
                    <div className="flex flex-col flex-wrap justify-between gap-4 md:grid md:grid-cols-2 xl:grid-cols-3">
                        {bigNavCards?.length > 0
                            && bigNavCards.map(({
                                key,
                                heading,
                                body,
                                link,
                                image,
                                target,
                                externalStyles,
                                externalTextBoxStyles,
                                externalContainerStyles,
                            }) => (
                                <BigNavigationCard
                                    key={key}
                                    heading={heading}
                                    body={body}
                                    link={link}
                                    target={target}
                                    image={image}
                                    externalStyles={externalStyles}
                                    externalTextBoxStyles={externalTextBoxStyles}
                                    externalContainerStyles={externalContainerStyles}
                                />
                            ))}
                        {cards?.length > 0
                            && cards.map(({
                                key,
                                image,
                                body,
                                button,
                                heading,
                                externalStyles,
                                alpha,
                            }) => (
                                <NavigationCard
                                    key={key}
                                    image={image}
                                    body={body}
                                    heading={heading}
                                    button={button}
                                    externalStyles={externalStyles}
                                    alpha={alpha}
                                />
                            ))}
                    </div>
                </div>
            </div>
        </Page>
    );
}

export default LandingWithCards;
